import AmexShopSmallIntroBanner from './AmexShopSmallIntroBanner';

export default AmexShopSmallIntroBanner;
